import {
  BsBuildingCheck,
  BsBuildingGear,
  BsFileEarmarkArrowUp,
  BsFilePdf,
  BsFileSpreadsheet,
  BsFillPinMapFill,
  BsListColumnsReverse,
  BsTable,
} from "react-icons/bs";
import { FaCameraRetro, FaFileInvoiceDollar } from "react-icons/fa6";
import { GiChart, GiSouthAmerica } from "react-icons/gi";
import { HiOutlineFire, HiOutlineUser, HiOutlineUsers, HiOutlineIdentification } from "react-icons/hi2";
import { IoBusiness } from "react-icons/io5";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { LuClipboardList } from "react-icons/lu";
import { MdOutlineCategory } from "react-icons/md";
import { PiListPlusLight, PiSuitcaseSimpleThin } from "react-icons/pi";
import { SiAffinitydesigner, SiOutline } from "react-icons/si";
import {
  TbUserDollar,
  TbCalendarCog,
  TbReportSearch,
  TbBuildingCircus,
  TbChartLine,
  TbBuildingCommunity,
  TbUserScreen,
  TbTargetArrow,
  TbCash,
  TbReceiptTax,
  TbBook2,
  TbBusinessplan,
  TbMail,
  TbTruckDelivery,
} from "react-icons/tb";
import { TfiMoney } from "react-icons/tfi";
import { ADMIN_IDS, INVERSORES_RESTRINGIDOS, MAILING_IDS } from "./permisos";
import { ROLES } from "./roles";

const icon = (Icon) => <Icon className="icon" />;

export const UTILITARIAS_BASE = [
  { path: "/inventario", icon: icon(IoBusiness), text: "Inventario" },
  { path: "/mediakit", icon: icon(SiAffinitydesigner), text: "Mediakit" },
  { path: "/portafolio", icon: icon(PiSuitcaseSimpleThin), text: "Portafolio" },
  { path: "/mapa", icon: icon(BsFillPinMapFill), text: "Mapa" },
  { path: "/listadoempresas", icon: icon(BsListColumnsReverse), text: "Empresas por edificio" },
  { path: "/categorias", icon: icon(MdOutlineCategory), text: "Análisis Categorías" },
  { path: "/simulador-impacto", icon: icon(TbTargetArrow), text: "Simulador Impacto" },
  { path: "/galeria", icon: icon(FaCameraRetro), text: "Galería" },
];

export const getIpsosItem = (pais) => ({
  path: "/investigacion-ipsos",
  icon: icon(TbReportSearch),
  text: pais === "Perú" ? "IPSOS (Chile)" : "Respaldo IPSOS",
});

// Ítem de Perfil
const PERFIL_ITEM = { path: "/admin/perfil", icon: icon(HiOutlineUser), text: "Mi Perfil" };

// Ítem de Proyección Comercial
const PROYECCION_ITEM = { path: "/admin/ventas-proyeccion", icon: icon(GiChart), text: "Proyección Comercial" };

// Ítem Dashboard Financiero
const DASHBOARD_FIN_ITEM = {
  path: "/admin/dashboard-financiero",
  icon: icon(TbChartLine),
  text: "Dashboard",
  disabled: true,
};

// Ítem ER
const ER_ITEM = { path: "/admin/er", icon: icon(BsTable), text: "ER" };
const ER_V2_ITEM = { path: "/admin/er-v2", icon: icon(BsTable), text: "ER v2" };

// Ítem Flujo de Caja
const FLUJO_CAJA_ITEM = { path: "/admin/flujo-caja", icon: icon(TbCash), text: "Caja" };

// Ítem Dashboard IVA
const DASHBOARD_IVA_ITEM = { path: "/admin/dashboard-iva", icon: icon(TbReceiptTax), text: "IVA" };

// Ítem Estado de Cuenta
const ESTADO_CUENTA_ITEM = { path: "/admin/estado-cuenta", icon: icon(TbBook2), text: "Estado de Cuenta" };

// Ítem Factoring
const FACTORING_ITEM = { path: "/admin/factoring", icon: icon(TbBusinessplan), text: "Factoring" };

// Ítem Conciliación SII
// Integrados en Flujo de Caja — rutas siguen activas en App.js
// const CONCILIACION_SII_ITEM = { path: "/admin/conciliacion-sii", ... };
// const MOVIMIENTOS_BANCARIOS_ITEM = { path: "/admin/movimientos-bancarios", ... };

// Ítem Reporte Fotográfico
const REPORTE_FOTO_ITEM = {
  path: "/admin/reporte-fotografico",
  icon: icon(FaCameraRetro),
  text: "Reporte Fotográfico",
};

// Ítem Cotizaciones Generadas
const COTIZACIONES_GENERADAS_ITEM = {
  path: "/admin/cotizaciones-generadas",
  icon: icon(BsFilePdf),
  text: "Cotizaciones",
};

// Ítem Mailing (solo visible para ADMIN_IDS)
const MAILING_ITEM = { path: "/admin/mailing", icon: icon(TbMail), text: "Mailing" };
const mailingIf = (id) => (MAILING_IDS.includes(id) ? [MAILING_ITEM] : []);
const erV2If = (id) => (ADMIN_IDS.includes(Number(id)) ? [ER_V2_ITEM] : []);

// Helper: renombra "Mediakit" → "Mediakit Publicitario" y agrega "Mediakit Edificios" (link externo)
const withMediakitEdificios = (items, pais) => {
  const renamed = items.map((item) => (item.text === "Mediakit" ? { ...item, text: "Mediakit Publicitario" } : item));
  const mediakitEdificios = {
    path: pais === "Chile" ? "https://wecast.cl/edificios" : "https://visiona.pe/edificios",
    icon: icon(TbBuildingCommunity),
    text: "Mediakit Edificios",
    external: true,
  };
  const idx = renamed.findIndex((item) => item.text === "Mediakit Publicitario");
  if (idx !== -1) renamed.splice(idx + 1, 0, mediakitEdificios);
  else renamed.push(mediakitEdificios);
  return renamed;
};

const PROVEEDORES_ITEM = { path: "/admin/proveedores", icon: icon(TbTruckDelivery), text: "Proveedores" };

const GESTION_EMPLEADOS_ITEM = {
  path: "/admin/gestion-empleados",
  icon: icon(HiOutlineIdentification),
  text: "RRHH",
};

export const MENU_CONFIG = {
  // ==================== BOARD ====================
  [ROLES.BOARD]: {
    utilitarias: ({ pais }) =>
      withMediakitEdificios(
        UTILITARIAS_BASE.filter((h) => !["Análisis Categorías", "Respaldo IPSOS"].includes(h.text)),
        pais
      ),
    ventas: ({ id, pais }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      { path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" },
      PROYECCION_ITEM,
      {
        path: "/admin/cotizaciones",
        icon: icon(BsFileEarmarkArrowUp),
        text: `${pais === "Chile" ? "Perú" : "Chile"} & Agencias`,
      },
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      REPORTE_FOTO_ITEM,
    ],
    administrativas: ({ id }) => {
      const base = [
        { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
        { path: "/admin/informes-comision", icon: icon(BsBuildingGear), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Clientes" },
        PROVEEDORES_ITEM,
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
      ];
      if (ADMIN_IDS.includes(id)) {
        base.push({ path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" });
      }
      return base;
    },
    financieras: ({ id }) => {
      const isAdmin = ADMIN_IDS.includes(id);
      const base = [ER_ITEM];
      if (isAdmin)
        base.push(DASHBOARD_FIN_ITEM, FLUJO_CAJA_ITEM, DASHBOARD_IVA_ITEM, ESTADO_CUENTA_ITEM, FACTORING_ITEM);
      base.push({ path: "/admin/gestion-activos", icon: icon(SiOutline), text: "Gestión de Activos" });
      return base;
    },
  },
  // ==================== COMERCIAL ====================
  [ROLES.COMERCIAL]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, getIpsosItem(pais)], pais),
    ventas: ({ id, pais }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM & Ventas" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      { path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" },
      PROYECCION_ITEM,
      {
        path: "/admin/cotizaciones",
        icon: icon(BsFileEarmarkArrowUp),
        text: `${pais === "Chile" ? "Perú" : "Chile"} & Agencias`,
      },
      COTIZACIONES_GENERADAS_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      { path: "/admin/ventas-btl", icon: icon(TbBuildingCircus), text: "Below The Line" },
      REPORTE_FOTO_ITEM,
    ],
    administrativas: () => [
      { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
      { path: "/admin/mis-facturas", icon: icon(FaFileInvoiceDollar), text: "Comisión Comercial" },
      { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Clientes" },
      { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
      { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
      PERFIL_ITEM,
    ],
    financieras: () => [],
  },
  // ==================== GERENCIA ====================
  [ROLES.GERENCIA]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, getIpsosItem(pais)], pais),
    ventas: ({ id, pais }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      { path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" },
      PROYECCION_ITEM,
      {
        path: "/admin/cotizaciones",
        icon: icon(BsFileEarmarkArrowUp),
        text: `${pais === "Chile" ? "Perú" : "Chile"} & Agencias`,
      },
      COTIZACIONES_GENERADAS_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      { path: "/admin/ventas-btl", icon: icon(TbBuildingCircus), text: "Below The Line" },
      REPORTE_FOTO_ITEM,
    ],
    administrativas: ({ id }) => {
      const base = [
        { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
        { path: "/admin/informes-comision", icon: icon(BsBuildingGear), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Clientes" },
        PROVEEDORES_ITEM,
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
        { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
        { path: "/admin/cargar-intermediario", icon: icon(LuClipboardList), text: "Agencias" },
        GESTION_EMPLEADOS_ITEM,
        ...mailingIf(id),
        PERFIL_ITEM,
      ];
      return base;
    },
    financieras: ({ id }) => {
      const isAdmin = ADMIN_IDS.includes(id);
      const base = [ER_ITEM, ...erV2If(id)];
      if (isAdmin) base.push(DASHBOARD_FIN_ITEM);
      base.push(FLUJO_CAJA_ITEM, DASHBOARD_IVA_ITEM, ESTADO_CUENTA_ITEM, FACTORING_ITEM, {
        path: "/admin/gestion-activos",
        icon: icon(SiOutline),
        text: "Gestión de Activos",
      });
      return base;
    },
  },
  // ==================== SUPERADMIN ====================
  [ROLES.SUPERADMIN]: {
    utilitarias: () => UTILITARIAS_BASE,
    ventas: ({ allowedRegionIds, id, pais }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM & Ventas" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      { path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" },
      PROYECCION_ITEM,
      {
        path: "/admin/cotizaciones",
        icon: icon(BsFileEarmarkArrowUp),
        text: `${pais === "Chile" ? "Perú" : "Chile"} & Agencias`,
      },
      COTIZACIONES_GENERADAS_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      REPORTE_FOTO_ITEM,
      ...(allowedRegionIds.includes(id)
        ? [{ path: "/admin/ventas-region", icon: icon(GiSouthAmerica), text: "Región" }]
        : []),
    ],
    administrativas: ({ id, pais }) => {
      const base = [
        { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(FaFileInvoiceDollar), text: "Comisión Comercial" },
        { path: "/admin/informes-comision", icon: icon(BsBuildingGear), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Clientes" },
        PROVEEDORES_ITEM,
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
      ];
      if (ADMIN_IDS.includes(id)) {
        base.push({ path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" });
      }
      base.push(
        { path: "/admin/cargar-intermediario", icon: icon(LuClipboardList), text: "Agencias" },
        ...(pais === "Perú"
          ? [{ path: "/admin/cargar-oportunidad", icon: icon(LuClipboardList), text: "Cargar Oportunidad" }]
          : []),
        PERFIL_ITEM
      );
      return base;
    },
    financieras: ({ id }) => {
      const isAdmin = ADMIN_IDS.includes(id);
      const base = [ER_ITEM, ...erV2If(id)];
      if (isAdmin)
        base.push(DASHBOARD_FIN_ITEM, FLUJO_CAJA_ITEM, DASHBOARD_IVA_ITEM, ESTADO_CUENTA_ITEM, FACTORING_ITEM);
      return base;
    },
  },
  // ==================== ADMINISTRATIVO ====================
  [ROLES.ADMINISTRATIVO]: {
    utilitarias: () => UTILITARIAS_BASE,
    ventas: ({ id }) => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas" },
      PROYECCION_ITEM,
      { path: "/admin/clientes-cartera", icon: icon(PiListPlusLight), text: "Cartera Clientes" },
      { path: "/admin/carteleriiaa", icon: icon(TbUserScreen), text: "Cartelería" },
      REPORTE_FOTO_ITEM,
      COTIZACIONES_GENERADAS_ITEM,
    ],
    administrativas: ({ id, pais }) => {
      const base = [
        { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        ...(pais === "Chile"
          ? [{ path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" }]
          : []),
        { path: "/admin/informes-comision", icon: icon(BsBuildingGear), text: "Comisión Edificios" },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Clientes" },
        PROVEEDORES_ITEM,
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
        { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
        GESTION_EMPLEADOS_ITEM,
      ];
      return base;
    },
    financieras: ({ id }) => {
      const isAdmin = ADMIN_IDS.includes(id);
      const base = [ER_ITEM];
      if (isAdmin) base.push(DASHBOARD_FIN_ITEM);
      base.push(FLUJO_CAJA_ITEM, DASHBOARD_IVA_ITEM, ESTADO_CUENTA_ITEM, FACTORING_ITEM, {
        path: "/admin/gestion-activos",
        icon: icon(SiOutline),
        text: "Gestión de Activos",
      });
      return base;
    },
  },
  // ==================== OTROS ROLES ====================
  [ROLES.EDIFICIO]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, getIpsosItem(pais)], pais),
    ventas: () => [],
    administrativas: () => [],
    financieras: () => [{ path: "/admin/informes-comision", icon: icon(BsBuildingGear), text: "Comisión Edificios" }],
  },
  [ROLES.CONTABLE]: {
    utilitarias: () => [],
    ventas: () => [PROYECCION_ITEM],
    administrativas: () => [
      { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
      { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial" },
      { path: "/admin/informes-comision", icon: icon(BsBuildingGear), text: "Comisión Edificios" },
      PROVEEDORES_ITEM,
      { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
    ],
    financieras: ({ id }) => {
      const isAdmin = ADMIN_IDS.includes(id);
      const base = [ER_ITEM];
      if (isAdmin)
        base.push(DASHBOARD_FIN_ITEM, FLUJO_CAJA_ITEM, DASHBOARD_IVA_ITEM, ESTADO_CUENTA_ITEM, FACTORING_ITEM);
      base.push({ path: "/admin/gestion-activos", icon: icon(SiOutline), text: "Gestión de Activos" });
      return base;
    },
  },
  [ROLES.INVERSOR]: {
    utilitarias: ({ pais }) => withMediakitEdificios([...UTILITARIAS_BASE, getIpsosItem(pais)], pais),
    ventas: ({ id }) => {
      const restricted = INVERSORES_RESTRINGIDOS.includes(id);
      return [
        { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
        { path: "/admin/ventas-detalle", icon: icon(TfiMoney), text: "Ventas", disabled: restricted },
        { path: "/admin/mis-ventas", icon: icon(TbCalendarCog), text: "CRM", disabled: restricted },
        { path: "/admin/mapa-calor", icon: icon(HiOutlineFire), text: "Mapa de Calor" },
        { ...PROYECCION_ITEM, disabled: restricted },
        REPORTE_FOTO_ITEM,
      ];
    },
    administrativas: ({ id }) => {
      const restricted = INVERSORES_RESTRINGIDOS.includes(id);
      return [
        { path: "/admin/facturacion", icon: icon(LiaFileInvoiceDollarSolid), text: "Facturación" },
        { path: "/admin/mis-facturas", icon: icon(TbUserDollar), text: "Comisión Comercial", disabled: restricted },
        {
          path: "/admin/informes-comision",
          icon: icon(LuClipboardList),
          text: "Comisión Edificios",
          disabled: restricted,
        },
        { path: "/admin/cargar-cliente", icon: icon(LuClipboardList), text: "Clientes", disabled: restricted },
        { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios", disabled: restricted },
        { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
      ];
    },
    financieras: ({ id }) => {
      const restricted = INVERSORES_RESTRINGIDOS.includes(id);
      return [{ ...ER_ITEM, disabled: restricted }];
    },
  },
  [ROLES.AGENCIA]: {
    // utilitarias eliminada intencionalmente → usará el fallback base
    ventas: () => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-cotizaciones", icon: icon(LuClipboardList), text: "Mis Cotizaciones" },
      { path: "/admin/reporte-fotografico-externo", icon: icon(FaCameraRetro), text: "Reporte Fotográfico" },
    ],
    administrativas: () => [],
    financieras: () => [],
  },
  [ROLES.CLIENTE]: {
    // utilitarias eliminada intencionalmente → usará el fallback base
    ventas: () => [
      { path: "/admin/online-cotizador", icon: icon(BsFileSpreadsheet), text: "Cotizador" },
      { path: "/admin/mis-cotizaciones", icon: icon(LuClipboardList), text: "Mis Cotizaciones" },
      { path: "/admin/reporte-fotografico-externo", icon: icon(FaCameraRetro), text: "Reporte Fotográfico" },
    ],
    administrativas: () => [],
    financieras: () => [],
  },
  // ==================== INFRAESTRUCTURA ====================
  [ROLES.INFRAESTRUCTURA]: {
    utilitarias: () => UTILITARIAS_BASE,
    ventas: () => [],
    administrativas: () => [
      { path: "/admin/edificios", icon: icon(BsBuildingCheck), text: "Edificios" },
      { path: "/admin/usuarios", icon: icon(HiOutlineUsers), text: "Usuarios" },
    ],
    financieras: () => [],
  },
};
